import Footer from "../Components/Footer"
import Header from "../Components/Header"
import RespectivePlans from "../Components/Payment/RespectivePlans"

const RespectivePayment = () => {
  return (
    <div>
      <Header />
        <RespectivePlans/>
      <Footer p="5rem 9.6rem 0 9.6rem"/>
    </div>
  )
}

export default RespectivePayment
